/* miz-product-card.js
 * Single source for every .miz-product-card on the page (collection grid,
 * search, featured collection, related products, article blocks):
 * - card hover state (.is-hovered)
 * - image slider (.miz-product-card--slider): swipe on touch, hover shows
 *   slide 2 and arrows browse on mouse devices
 * - swatch click → swap the card's images to that colour
 * Everything is delegated on document, so cards inserted later (facet AJAX,
 * product recommendations, theme editor) work without re-init.
 */
(function () {
  if (window.__mizProductCard) return;
  window.__mizProductCard = true;

  var mouseQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

  function sliderOf(card) {
    return card ? card.querySelector('.miz-card-slider') : null;
  }

  // Slides in visual order (carrying-image mode shows the worn image first)
  function slidesOf(card) {
    var track = sliderOf(card);
    if (!track) return [];
    var slides = Array.prototype.slice.call(track.children);
    if (card.closest('[data-carrying-image="true"]')) {
      for (var i = 1; i < slides.length; i++) {
        if (slides[i].classList.contains('miz-card-slide--secondary')) {
          slides.unshift(slides.splice(i, 1)[0]);
          break;
        }
      }
    }
    return slides;
  }

  function loadSlide(slide) {
    var img = slide && slide.querySelector('img[data-src]');
    if (!img) return;
    img.src = img.getAttribute('data-src');
    img.removeAttribute('data-src');
  }

  function loadAll(card) {
    slidesOf(card).forEach(loadSlide);
  }

  function updateDots(card, index) {
    var dots = card.querySelectorAll('.miz-card-slider__dot');
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === index);
  }

  function currentIndex(card) {
    var track = sliderOf(card);
    if (!track) return 0;
    if (mouseQuery.matches) return card._mizIndex || 0;
    return track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
  }

  function goTo(card, index, smooth) {
    var track = sliderOf(card);
    var slides = slidesOf(card);
    if (!track || slides.length < 2) return;
    index = (index + slides.length) % slides.length;
    card._mizIndex = index;
    loadSlide(slides[index]);
    loadSlide(slides[(index + 1) % slides.length]);
    if (mouseQuery.matches) {
      track.setAttribute('data-touched', '');
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
    } else {
      track.scrollTo({ left: index * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    }
    updateDots(card, index);
  }

  function reset(card) {
    var track = sliderOf(card);
    if (!track) return;
    card._mizIndex = 0;
    track.removeAttribute('data-touched');
    slidesOf(card).forEach(function (slide, i) { slide.classList.toggle('is-active', i === 0); });
    track.scrollLeft = 0;
    updateDots(card, 0);
  }

  /* ── Hover (mouse devices) ─────────────────────────────────────────────── */
  function onEnter(card) {
    card.classList.add('is-hovered');
    if (!card.classList.contains('miz-product-card--slider')) return;
    loadAll(card);
    if (card.hasAttribute('data-hover-advance') && mouseQuery.matches) goTo(card, 1);
  }

  function onLeave(card) {
    card.classList.remove('is-hovered');
    if (card.classList.contains('miz-product-card--slider') && mouseQuery.matches) {
      card._mizIndex = 0;
      var track = sliderOf(card);
      if (track) {
        slidesOf(card).forEach(function (slide, i) { slide.classList.toggle('is-active', i === 0); });
      }
      updateDots(card, 0);
    }
  }

  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest('.miz-product-card');
    if (card && !card.contains(e.relatedTarget)) onEnter(card);
  });
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('.miz-product-card');
    if (card && !card.contains(e.relatedTarget)) onLeave(card);
  });

  /* ── Swipe (touch devices) ─────────────────────────────────────────────── */
  document.addEventListener('touchstart', function (e) {
    var track = e.target.closest && e.target.closest('.miz-card-slider');
    if (track) loadAll(track.closest('.miz-product-card'));
  }, { passive: true });

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track.classList || !track.classList.contains('miz-card-slider')) return;
    if (track._mizRaf) return;
    track._mizRaf = requestAnimationFrame(function () {
      track._mizRaf = null;
      var card = track.closest('.miz-product-card');
      loadAll(card);
      updateDots(card, currentIndex(card));
    });
  }, true);

  /* ── Arrows + swatches ─────────────────────────────────────────────────── */
  function swapLegacy(card, swatch) {
    var media = card.querySelector('.miz-product-card__media');
    if (!media) return;
    var imgUrl = swatch.getAttribute('data-image');
    if (imgUrl) {
      var mainImg = media.querySelector('.miz-product-card__img:not(.miz-product-card__img--hover)');
      if (mainImg) { mainImg.src = imgUrl; mainImg.removeAttribute('srcset'); }
    }
    var hoverImg = media.querySelector('.miz-product-card__img--hover');
    var isFirst = swatch.getAttribute('data-variant-index') === '0';
    var inspirationUrl = swatch.getAttribute('data-inspiration') ||
      (isFirst ? media.getAttribute('data-inspiration') || '' : '');
    if (inspirationUrl && hoverImg) {
      hoverImg.src = inspirationUrl;
      hoverImg.removeAttribute('srcset');
      hoverImg.style.display = '';
      card.classList.remove('miz-product-card--no-hover');
    } else {
      if (hoverImg) {
        hoverImg.removeAttribute('src');
        hoverImg.removeAttribute('srcset');
        hoverImg.style.display = 'none';
      }
      card.classList.add('miz-product-card--no-hover');
    }
  }

  function swapSlides(card, swatch) {
    var track = sliderOf(card);
    var urls = (swatch.getAttribute('data-slides') || '').split('|').filter(Boolean);
    if (!track || !urls.length) return;
    var firstImg = track.querySelector('.miz-card-slide__img');
    var alt = (firstImg ? firstImg.getAttribute('alt') || '' : '').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
    var hasSecondary = swatch.hasAttribute('data-has-secondary');

    var html = urls.map(function (url, i) {
      var cls = 'miz-card-slide' + (i === 0 ? ' is-active' : '') +
        (i === 1 && hasSecondary ? ' miz-card-slide--secondary' : '');
      return '<div class="' + cls + '"><img class="miz-card-slide__img" src="' + url +
        '" alt="' + (i === 0 ? alt : '') + '" width="600" height="600" decoding="async"></div>';
    }).join('');
    track.innerHTML = html;

    var count = urls.length;
    card.querySelectorAll('.miz-card-slider__arrow').forEach(function (arrow) { arrow.hidden = count < 2; });
    var dots = card.querySelector('.miz-card-slider__dots');
    if (dots) {
      dots.hidden = count < 2;
      dots.innerHTML = new Array(count + 1).join('<span class="miz-card-slider__dot"></span>');
    }
    card.classList.toggle('miz-product-card--no-hover', count < 2);
    reset(card);
    if (card.classList.contains('is-hovered') && card.hasAttribute('data-hover-advance') && mouseQuery.matches) {
      goTo(card, 1);
    }
  }

  function activateSwatch(swatch) {
    var card = swatch.closest('.miz-product-card');
    if (!card) return;
    if (card.classList.contains('miz-product-card--slider')) swapSlides(card, swatch);
    else swapLegacy(card, swatch);
    var group = swatch.closest('.miz-product-card__swatches');
    if (group) {
      group.querySelectorAll('.miz-product-card__swatch').forEach(function (s) { s.classList.remove('is-active'); });
    }
    swatch.classList.add('is-active');
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var arrow = e.target.closest('.miz-card-slider__arrow');
    if (arrow) {
      e.preventDefault();
      e.stopPropagation();
      var card = arrow.closest('.miz-product-card');
      goTo(card, currentIndex(card) + Number(arrow.getAttribute('data-dir')), true);
      return;
    }
    // Swatches sit inside the card link: never navigate from them
    if (!e.target.closest('.miz-product-card__swatches')) return;
    e.preventDefault();
    var swatch = e.target.closest('.miz-product-card__swatch');
    if (swatch) activateSwatch(swatch);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var swatch = e.target.closest && e.target.closest('.miz-product-card__swatch');
    if (!swatch) return;
    e.preventDefault();
    activateSwatch(swatch);
  });

  /* ── Facet "Tragebilder" toggle changes the first slide ────────────────── */
  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('facet-image-mode')) return;
    setTimeout(function () {
      document.querySelectorAll('.miz-product-card--slider').forEach(reset);
    }, 0);
  });
})();
